import {skipToken} from '@reduxjs/toolkit/query';
import {DataStatus} from 'platform/components';
import {Show} from 'platform/foundation';

import {useLocation, useParams} from 'react-router-dom';

import {isEmpty, isNil, isNotNil} from 'ramda';

import {useGetCheckoutProfileRuleQuery} from '@dms/api/sales';
import {useGetCurrentBranch} from '@dms/shared';

import {CheckoutRuleEditor} from './components/CheckoutRuleEditor';

// URLSearchParams.get returns '' for a parameter without a value; such an id counts as missing.
const getIdParam = (params: URLSearchParams, name: string) => {
  const value = params.get(name);

  return isNil(value) || isEmpty(value) ? undefined : value;
};

export function CheckoutRuleDetail() {
  const {id} = useParams();
  const {search} = useLocation();
  const {activeBranchId} = useGetCurrentBranch();
  const params = new URLSearchParams(search);
  const {
    currentData: rule,
    isFetching,
    isError,
  } = useGetCheckoutProfileRuleQuery(isNotNil(id) ? {checkoutProfileRuleId: id} : skipToken);

  return (
    <DataStatus
      isLoading={isNotNil(id) && isNil(rule) && isFetching}
      isError={isError}
      minHeight={60}
    >
      <Show when={isNil(id) || rule}>
        <CheckoutRuleEditor
          key={id ?? 'new'}
          initialRule={rule}
          branchId={getIdParam(params, 'branchId') ?? activeBranchId ?? undefined}
          checkoutProfileId={getIdParam(params, 'checkoutProfileId')}
          returnProfileId={getIdParam(params, 'returnProfileId')}
        />
      </Show>
    </DataStatus>
  );
}
